import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { fetchClientAdministration } from 'utils/fetchers';
import { patchClient } from 'store/administration/administrationActions';
import AdministrationClient from './AdministrationClient';

class AdministrationClientContainer extends React.Component {
    
    constructor(props) {
        super(props);
        
        this.state = {
            client: null
        };
    }

    async componentDidMount() {
        const { id } = this.props;

        var client = await this.props.fetchClientAdministration(id);
        
        console.log("componentDidMount client ", client);

        this.setState({client : client});
    }

    handleChange = (event) => {
        let newClient = this.state.client;

        if (event.target.name === 'autoriseNotificationSouffranceTransporteur') {
            newClient.autoriseNotificationSouffranceTransporteur = !newClient.autoriseNotificationSouffranceTransporteur;
        }

        if (event.target.name === 'prioritaire') {
            newClient.prioritaire = !newClient.prioritaire;
        }

        if (event.target.name === 'pctJokerFraisRetour') {
            newClient.pctJokerFraisRetour = event.target.value;
        }

        this.setState({ ...this.state, client: newClient });
    };

    handleClickSave = async (event, id) => {
        await this.props.patchClient(this.state.client);
    };

    render() {
        const { client } = this.state;
        
        return (
            <AdministrationClient
                client={client}
                isPatching={false}
                onChange={this.handleChange}
                onClickSave={this.handleClickSave}
            />);
    }
}

AdministrationClientContainer.propTypes = {
    id: PropTypes.number
};

const mapStateToProps = state => ({
    //isLoading: state.administration.causesPrincipales.isLoading,
    //isPatching: state.administration.causesPrincipales.isPatching,
    //causesPrincipales: state.administration.causesPrincipales.items
});

const mapDispatchToProps = dispatch => ({
    fetchClientAdministration: (clientId) => dispatch(fetchClientAdministration(clientId)),
    patchClient: (client) => dispatch(patchClient(client))
});

export default connect(mapStateToProps, mapDispatchToProps)(AdministrationClientContainer);